<template>
    <svg width="44" height="17" viewBox="0 0 44 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M42 5H0V2V0H41H42C43.1046 0 44 0.895431 44 2V3V6.56995C44 8.02133 42.961 9.26456 41.5327 9.52228L0 17V15L41.1776 7.55406C41.6537 7.46815 42 7.05374 42 6.56995V5Z" fill="currentColor"/>
    </svg>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

</style>
